import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { Theme } from "@mui/material/styles/createTheme";
import theme from "./theme";
import { limitMaxResolutionStyles } from "./common/Common.style";

export const Root = styled(Box)(() => ({
  backgroundColor: theme.deadSpaceBackground,
}));

export const AppContainer = styled(Box)(({ theme }) => ({
  ...limitMaxResolutionStyles,
  backgroundColor: (theme as Theme).palette.background.default,
  position: "relative",
}));
